import clsx from 'clsx';
import React, { useState, useEffect, useRef } from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './MobileSortBtn.module.scss';
import { SortOption } from '../../../types';

interface MobileSortBtnProps extends React.PropsWithChildren<any> {
    options: SortOption[];
    currentSorting: string;
    currentOrder: string;
    onChange: (option: SortOption) => void;
}

const MobileSortBtn: React.FC<MobileSortBtnProps> = ({
    options,
    currentSorting,
    currentOrder,
    onChange
}) => {
    const st: CssModuleType = currentCssModule;

    const containerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(
        options?.find(
            (item) => item.data === currentSorting && item.sort_order === currentOrder && item.display_name
        )
    );

    const handleOptionClick = (option) => {
        setSelectedValue(option);
        onChange && onChange(option);
        setIsOpen(false);
    };

    useEffect(() => {
        setIsOpen(false);
    }, [selectedValue]);

    useEffect(() => {
        function handleOutsideClick(event) {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const renderSelectedValue = () => {
        if (!options) return;
        if (!selectedValue) return options[0]?.display_name;
        return selectedValue.display_name;
    };

    return (
        <div ref={containerRef} className={clsx(st['mobile-sort-btn'])}>
            <ul onClick={() => setIsOpen(!isOpen)}>
                <li className={st.selected}>
                    <i className='far fa-sort'></i>
                    {renderSelectedValue()}
                    <i className='far fa-angle-down'></i>
                </li>
                {options && isOpen && (
                    <ul>
                        {options.map((option, ind) => (
                            <li
                                data-data={option.display_name}
                                key={`${option.display_name}_${ind}`}
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.display_name}
                            </li>
                        ))}
                    </ul>
                )}
            </ul>
        </div>
    );
};

export default MobileSortBtn;
